module.exports = __webpack_public_path__ + "img/Login-Seite_Unten_1.bf107d05.webp";